'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _PrintLoadNextButton = require('./components/PrintLoadNextButton.component');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_PrintLoadNextButton).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/print/lib/components/print-load-next-button/index.js
// module id = 1449
// module chunks = 1